import React from 'react'
import { Route, Routes } from "react-router-dom";
// import Contact from '../pages/public/Contact';
import Error404 from "../pages/public/Error404";
import Homepage from '../pages/public/Homepage';
import Residencies from '../pages/public/Residencies';
import Availability from '../pages/public/Availability';
import Animities from '../pages/public/Animities';
import AvailabilityDetails from '../pages/public/AvailabilityDetails';
import AboutUs from '../pages/public/AboutUs';
import RezidenciesDetails from '../pages/public/RezidenciesDetails';
import RezidenciesOffert from '../pages/public/RezidenciesOffert';
import Compare from '../pages/public/Compare';
import TermsAndConditions from '../pages/public/TermsAndConditions';
import ConfirmEmail from '../pages/public/ConfirmEmail';
import ConfirmMobile from '../pages/public/ConfirmMobile';
import SentEmail from '../pages/public/SentEmail';
// import TestSite from '../pages/private/TestSite';
import PrivacyPolicy from '../components/consent/PrivacyPolicy';
import Blogs from '../pages/public/Blogs';
import BlogContent from '../pages/public/BlogContent';
import { Helmet } from 'react-helmet-async';

// Route Wrapper with Helmet for meta tags
const RouteWithHelmet = ({ title, description, element }) => (
    <>
        <Helmet>
            <title>{title ? title : "Fundway - Exclusive Vlora Marina Properties in Albania"}</title>
            <meta name="description" content={description ? description : "Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."} />
        </Helmet>
        {element}
    </>
);

export default function AllRoutes() {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<Homepage />}
                    />
                }
            />

            <Route
                path="/properties"
                element={<Residencies />}
            />
            <Route
                path="/residencieDetails/:id"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<RezidenciesDetails />}
                    />
                }
            />
            <Route
                path="/reserve/:id"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<RezidenciesOffert />}
                    />
                }
            />

            <Route
                path="/compare/:id"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<Compare />}
                    />
                }
            />

            <Route
                path="/amenities"
                element={
                    <RouteWithHelmet
                        title="Premium Amenities - Experience Luxury at Vlora Marina"
                        description="Discover world-class amenities at Fundway's exclusive properties, including the refined comforts of Vlora Marina."
                        element={<Animities />}
                    />
                }
            />
            <Route
                path="/availability"
                element={
                    <RouteWithHelmet
                        title="Fundway Property Availability - Invest in Vlora Marina & More"
                        description="Explore available investment opportunities with Fundway, including premium residences at Vlora Marina. Secure your spot today."
                        element={<Availability />}
                    />
                }
            />
            <Route
                path="/availability/:id"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<AvailabilityDetails />}
                    />
                }
            />
            <Route
                path='/aboutus'
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<AboutUs />}
                    />
                }
            />
            <Route
                path="/termsAndConditions"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<TermsAndConditions />}
                    />
                }
            />
            <Route
                path="/userData"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<SentEmail />}
                    />
                }
            />

            <Route
                path="/confirmEmail/:id"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<ConfirmEmail />}
                    />
                }
            />
            <Route
                path="/confirmMobile/:id"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<ConfirmMobile />}
                    />
                }
            />
            {/* <Route 
                path="/apiTestSite" 
                element={<TestSite />} 
            /> */}
            <Route
                path="/blogs"
                element={
                    <RouteWithHelmet
                        title="Fundway Insights - Real Estate Trends"
                        description="Stay informed with expert insights on real estate investments, market trends, and Fundway's latest property developments."
                        element={<Blogs />}
                    />
                }
            />
            <Route
                path="/blogs/:id"
                element={<BlogContent />}
            />

            <Route
                path="/privacypolicy"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<PrivacyPolicy />}
                    />
                }
            />

            <Route
                path="*"
                element={
                    <RouteWithHelmet
                        title="Fundway - Exclusive Vlora Marina Properties in Albania"
                        description="Explore refined Vlora Marina properties with sea views, 80% financing, and fixed 3.7% rates - your gateway to premier Vlora properties."
                        element={<Error404 />}
                    />
                }
            />

        </Routes>
    )
}